export {
  OnboardingRangeSelectionQuestion,
  OnboardingRangeSelectionQuestionProps,
} from './OnboardingRangeSelectionQuestion';
